import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  childColors: [],   
  childColor: null,
  success: false,
  error: null,
  message: null,
};

export const childColorReducer = createReducer(initialState, (builder) => {
  builder
    // --- CREATE ---
    .addCase("createChildColorRequest", (state) => {
      state.isLoading = true;
      state.success = false;
    })
    .addCase("createChildColorSuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.childColor = action.payload;
    })
    .addCase("createChildColorFail", (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.payload;
    })

    // --- GET ALL ---
    .addCase("getAllChildColorsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getAllChildColorsSuccess", (state, action) => {
      state.isLoading = false;
      state.childColors = action.payload;
    })
    .addCase("getAllChildColorsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // --- GET ONE ---
    .addCase("getOneChildColorRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getOneChildColorSuccess", (state, action) => {
      state.isLoading = false;
      state.childColor = action.payload;
    })
    .addCase("getOneChildColorFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // --- UPDATE ---
    .addCase("updateChildColorRequest", (state) => {
      state.isLoading = true;
      state.success = false;
    })
    .addCase("updateChildColorSuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.childColor = action.payload;
    })
    .addCase("updateChildColorFail", (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.payload;
    })

    // --- DELETE ---
    .addCase("deleteChildColorRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("deleteChildColorSuccess", (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
    })
    .addCase("deleteChildColorFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // --- CLEAR ERRORS ---
    .addCase("clearErrors", (state) => {
      state.error = null;
    });
});
